import { axiosClient } from '../../../../utils/axiosClient';
import { makeApiRequest, type ApiResponse } from '../../../utils';
import { OnlineGivingEndpoints } from './onlineGivingEndpoints';
import type { GetClientAccessTokenResponse } from './response';

export class OnlineGivingService {
    public async getClientAccessToken(): Promise<
        ApiResponse<GetClientAccessTokenResponse>
    > {
        const url = OnlineGivingEndpoints.getClientAccessToken();
        const httpRequest = axiosClient.post(
            url,
            { grantType: 'client_credentials' },
            { headers: { Authorization: '-' } },
        );
        return makeApiRequest<GetClientAccessTokenResponse>(httpRequest);
    }
}
